// @flow
import * as React from 'react';
import { Field } from 'redux-form';

import Input from './Checkbox';

type Props = {
	name: string,
	label: React.Element<*>,
	className?: string,
};

export default class Checkbox extends React.PureComponent<Props> {
	static defaultProps = {
		className: '',
	};

	render() {
		const { name, label, className } = this.props;
		const InputComponent = props => <Input {...props} className={className} label={label} />;

		return <Field {...this.props} type="checkbox" name={name} component={InputComponent} />;
	}
}
